<template>
    <div class="wrapper">
        <transition name="move" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    export default {
        data(){
            return {}
        },
        components:{
        },
        created(){
        },
        methods: {
            ks(){
                alert('Coming soon')
            },
        },
    }
</script>
<style>
</style>